import React, { useMemo } from 'react';
import xss from 'xss';
import { jsx as _jsx } from "react/jsx-runtime";
export var ComponentWithInnerHTML = function ComponentWithInnerHTML(_ref) {
  var _ref$as = _ref.as,
    AsComponent = _ref$as === void 0 ? 'div' : _ref$as,
    html = _ref.html,
    className = _ref.className,
    setHtmlOptions = _ref.setHtmlOptions,
    testId = _ref.testId;
  var memoedHtmlString = useMemo(function () {
    return xss(html, setHtmlOptions);
  }, [html, setHtmlOptions]);
  return /*#__PURE__*/_jsx(AsComponent, {
    className: className,
    dangerouslySetInnerHTML: {
      __html: memoedHtmlString
    },
    "data-testid": testId
  });
};